module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAATCAYAAABGKffQAAAABHNCSVQICAgIfAhkiAAAAC9JREFUKJFj+P//f8N/CGhgIAT+owL8GpBMHtVAVQ37kVVTbvLIVAhVTFLAE51TAGRMTZIG1M5IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(4).png
// module id = LO0a
// module chunks = 1